
















































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { StudentInfo } from "../../_models/studentInfo";
import * as data from "../../_store/data.module";
import { bus } from "../../main"

@Component
export default class DetailsStudentInfoTab extends Vue {
  @Prop() info!: StudentInfo;
  @Prop() userType!: string;

  private stateName: string
  private comuneName: string
  private provinciaName: string

  constructor(){
    super()
    this.stateName = ""
    this.comuneName = ""
    this.provinciaName = ""
  }

  created() {
    bus.$on("stateName", (data: any) =>{
      this.stateName = data
    })

    bus.$on("comuneName", (data: any) =>{
      this.comuneName = data.località
      this.provinciaName = data.provincia
    })
  }
}
